import styled from '@emotion/styled';
import { Select } from '@material-ui/core';

const StyledSelect = styled(Select)({
  height: 48,
  '.MuiOutlinedInput-input': {
    padding: '16px 36px 16px 12px',
  },
  '&.MuiInputBase-root': {
    fontWeight: 600,
    fontSize: 14,
    textAlign: 'center',
    color: '#4C566C',
    background: '#FFFFFF',
  },
  '&.MuiOutlinedInput-notchedOutline': {
    borderColor: '#E6E7E8',
  },
});

export default StyledSelect;
